import { render, staticRenderFns } from "./ReviewTemplate.vue?vue&type=template&id=6014750a"
import script from "./ReviewTemplate.vue?vue&type=script&lang=js"
export * from "./ReviewTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports